"use client";

import { useState } from "react";
import { useToast } from "../components/context/ToastContext";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { IHistory } from "../interfaces/history";
import { concluirConsulta, fetchHistory } from "../services/historyService";

export function useHistory(initialPage: number = 1) {
  const showToast = useToast();
  const queryClient = useQueryClient();

  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(initialPage);
  const [filters, setFilters] = useState({
    protocol: "",
    document: "",
    startDate: "",
    endDate: "",
    status: "",
    deviceId: "",
    geoLocalizacao: "",
    ip: "",
    cpf: "",
    deviceIp: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(filters);
  const [showConcludeModal, setShowConcludeModal] = useState(false);
  const [pendingCompany, setPendingCompany] = useState<IHistory | null>(null);

  const HistoryQuery = useQuery<
    { items: IHistory[]; totalCount: number },
    Error,
    { History: IHistory[]; totalPages: number }
  >({
    queryKey: ["History", pageNumber, appliedFilters],
    queryFn: () => fetchHistory(pageNumber, filters),
    select: (apiResponse: any) => {
      console.log("apiResponse", apiResponse);
      const items = apiResponse.data.data || [];
      const totalPages = apiResponse.data.totalPages || 1;
      return { History: items, totalPages };
    },
    //@ts-ignore
    onError: () => {
      showToast("error", "Erro ao buscar.");
    },
  });

  const mutationConcluir = useMutation<void, Error, string>({
    mutationFn: (protocol: string) => concluirConsulta(protocol),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["History"] });
      showToast("success", "Sucesso ao concluir item");
      setShowConcludeModal(false);
    },
    onError: () => {
      showToast("error", "Erro ao concluir item.");
    },
  });

  const openConcludeModal = (company: IHistory) => {
    setPendingCompany(company);
    setShowConcludeModal(true);
  };

  const confirmConclude = () => {
    if (pendingCompany) {
      mutationConcluir.mutate(pendingCompany.protocol || "");
    }
  };

  return {
    History: HistoryQuery.data?.History || [],
    totalPages: HistoryQuery.data?.totalPages || 1,
    isLoading: HistoryQuery.isLoading,

    search,
    setSearch,
    pageNumber,
    setPageNumber,

    filters,
    setFilters,
    setAppliedFilters,
    refetchHistory: HistoryQuery.refetch,
    mutationConcluir,
    confirmConclude,
    openConcludeModal,
    showConcludeModal,
    setShowConcludeModal,
    pendingCompany,
  };
}
